module.exports = __webpack_public_path__ + "img/6.0dd40e6c.png";